// components/FollowButton.tsx
import React, { useEffect, useState } from 'react';
import { subscribeKeychain } from 'helpers/keychain';
import { subscribeWithWif } from 'helpers/steem';
import { isLoggedWithKeychain } from 'services/dsteem-service'; 
// import LoginModal from 'features/user/userModals/LoginModal';
import { useAuth } from 'helpers/authContext'; 

type Props = {
  community: any;
  onLogin: Function;
  className?: string; 
  disabled?: boolean;
};

const SubscribeButton = ({ community, onLogin, className,  disabled = false }: Props) => {
  const { user, autologin } = useAuth();
  const [hasSubscribed, setHasSubscribed] = useState(false); 
  const [loading, setLoading] = useState(false);

  const keychainLogin = isLoggedWithKeychain(autologin);

  useEffect(() => {
    if (!community && !community?.context) return;
    setLoading(false);
    setHasSubscribed(community?.context?.subscribed || false);
  }, [community]); 

  const handleSubscribe = async () => {
    if (!user) onLogin();
    setLoading(true);

    const type = hasSubscribed ? 'unsubscribe' : 'subscribe';
    const fn = keychainLogin ? subscribeKeychain : subscribeWithWif;

    try {
      const result:any = await fn(keychainLogin ? user : autologin, community.name, type );

      if (result.success) {
        setHasSubscribed(!hasSubscribed); 
      } else {
        console.log('Subscribe operation failed.');
      }
    } catch (err) {
      console.log('Error subscribing: ' + err);
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <button
      className={(hasSubscribed ? 'disabled-action-button' : 'action-button')+" "+className}
      onClick={handleSubscribe}
      disabled={loading || disabled}
      style={{minWidth:"127px"}}
    > 
      {loading && <span className="spinner" />}
      {!loading && (hasSubscribed ? 'Unsubscribe' : 'Subscribe')}
    </button>
  );
};

export default SubscribeButton;
